import { render } from "./review-settings.vue?vue&type=template&id=03f9e401&scoped=true"
import script from "./review-settings.vue?vue&type=script&lang=js"
export * from "./review-settings.vue?vue&type=script&lang=js"

import "./review-settings.vue?vue&type=style&index=0&id=03f9e401&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f9e401"]])

export default __exports__